import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Button, Divider, Empty, message, Select, Spin, Switch } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import {
  apiChangeRegistrationStatus,
  apiGetRegistrationDetail,
  apiGetRegistrationList,
} from "services/dashboardService";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import "./Dashboard.css";
import ClubTable from "./ClubTable/ClubTable";
import ClubBoxWidget from "components/ClubBoxWidget/ClubBoxWidget";
import { ROUTE_HOME_SETTING } from "navigation/CONSTANTS";
const { Option } = Select;
const Dashboard = (props) => {
  const history = useHistory();
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);
  const [isBusy, setIsBusy] = useState(false);

  const [regInfoList, setRegInfoList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [hideHiddenRegistrations, setHideHiddenRegistrations] = useState(false);

  useEffect(() => {
    if (appDataStore.club != undefined) {
      fetchAllRegistrationsWithDetails(appDataStore.club.id);
    } else {
      setRegInfoList([]);
      setUserList([]);
    }
  }, [appDataStore.club]);

  // Fetch all registrations, then fetch details for each
  const fetchAllRegistrationsWithDetails = async (clubId) => {
    setIsBusy(true);
    try {
      const params = new URLSearchParams();
      params.append("token", userDataStore.token);
      params.append("club_id", clubId);
      const registrations = await apiGetRegistrationList(params);
      console.log("Registrations:", registrations);
      // Fetch details for each registration in parallel
      const detailPromises = registrations.map(async (reg) => {
        const detailParams = new URLSearchParams();
        detailParams.append("token", userDataStore.token);
        detailParams.append("registration_id", reg.ID);
        detailParams.append("sport_type", userDataStore?.sport_type);
        const detailRes = await apiGetRegistrationDetail(detailParams);
        console.log("Detail response:", detailRes);
        let tmpList = [];
        tmpList = [...tmpList, detailRes.info];
        return {
          ...reg,
          balance: detailRes.info.balance,
          count: detailRes.info.count,
          discount: detailRes.info.discount,
          fee: detailRes.info.fee,
          name: detailRes.info.name,
          net_fee: detailRes.info.net_fee,
          refund: detailRes.info.refund,
          status: detailRes.info.status,
          transfer: detailRes.info.transfer,
        };
      });
      const regListWithDetails = await Promise.all(detailPromises);
      setRegInfoList(regListWithDetails);
      setIsBusy(false);
    } catch (err) {
      setIsBusy(false);
      message.error(err);
    }
  };

  const onChangeStatus = (info, newStatus) => {
    let tmpList = [...regInfoList];
    let tmpIndex = tmpList.findIndex((x) => x.name == info.name);
    tmpList[tmpIndex].status = newStatus;

    const statusValue = newStatus == "OPEN" ? 1 : newStatus == "HIDE" ? 2 : 0;
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", tmpList[tmpIndex].ID);
    params.append("status", statusValue);
    setIsBusy(true);
    apiChangeRegistrationStatus(params)
      .then((res) => {
        setRegInfoList(tmpList);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onDetail = (record) => {
    // Navigate to Home Setting for the clicked registration record
    const targetId = record?.ID;
    if (targetId) {
      history.push(ROUTE_HOME_SETTING + "/" + targetId);
    }
  };

  const handleExport = () => {
    if (!visibleRegInfoList.length) {
      message.warning("No data to export.");
      return;
    }
    const exportRows = visibleRegInfoList.map((row) => ({
      "Registration Form": row.name,
      "Participants": row.count,
      "Total Fees": parseFloat(row.fee || 0),
      "Discounts": parseFloat(row.discount || 0),
      "Net Fees": parseFloat(row.net_fee || 0),
      "Refunds": parseFloat(row.refund || 0),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");

    const today = new Date();
    const filename = `Registrations_${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const visibleRegInfoList = (
    hideHiddenRegistrations
      ? regInfoList.filter((x) => x.status !== "HIDE")
      : regInfoList
  )
    .slice()
    .sort((a, b) => (b.updated_at || 0) - (a.updated_at || 0));

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <div className="dashboard-page">
          <ClubBoxWidget newReg={true} disableRegistrationSelect />
          <div style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Divider
              style={{ borderTop: "4px solid var(--mainColor)" }}
            ></Divider>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 8,
                marginBottom: 12,
              }}
            >
              <Button icon={<DownloadOutlined />} onClick={handleExport}>
                Export
              </Button>
              <span>Hide Hidden Registrations:</span>
              <Switch
                checked={hideHiddenRegistrations}
                onChange={(checked) => setHideHiddenRegistrations(checked)}
              />
            </div>
            <ClubTable
              dataList={visibleRegInfoList}
              onChangeStatus={onChangeStatus}
              onDetail={onDetail}
            />
            {/* <RegFormTable dataList={userList} /> */}
          </div>
        </div>
      </Spin>
    </CommonDivWidget>
  );
};

export default Dashboard;
